<template>
	<VoicesListSkeleton v-if="isLoading" />
	<ul
		v-else
		class="voices-view"
	>
		<li
			v-for="voice in voices"
			:key="voice.id"
		>
			<VoiceItem
				:voice="voice"
				:isSelected="voice.id == selectedVoiceId"
				:playProgress="
					voice.id == selectedVoiceId ? voicePreviewProgress : undefined
				"
				@onClick="handleOnClickVoice"
			/>
		</li>
	</ul>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { onMounted, onUnmounted } from 'vue';

import { useStore } from '../../store';
import { Voice } from '../../types/Voice';

import VoiceItem from './components/VoiceItem.vue';
import VoicesListSkeleton from './VoicesViewSkeleton.vue';

const store = useStore();
const { voices, selectedVoiceId, voicePreviewProgress, isLoading } =
	storeToRefs(store);

const handleOnClickVoice = async (voice: Voice) => {
	if (voice.id === selectedVoiceId.value) {
		store.clearSelectedVoice();

		return;
	}

	await store.voiceSelected(voice.id);
};

const unselectVoice = (event: KeyboardEvent) => {
	if (event.key === 'Escape') {
		store.clearSelectedVoice();
	}
};

onMounted(() => {
	window.addEventListener('keydown', unselectVoice);
});

onUnmounted(() => {
	window.removeEventListener('keydown', unselectVoice);
});
</script>

<style scoped lang="scss">
.voices-view {
	position: relative;

	display: flex;
	flex-flow: row wrap;
	gap: var(--hy-space-md);
	justify-content: center;

	margin-bottom: var(--hy-space-5xl);
	padding: var(--hy-space-md) var(--hy-space-xs);

	list-style-type: none;
}
</style>
